import { Badge } from "@/components/ui/badge";

interface PrizeDetails {
  '1st'?: { item: string; value: number };
  '2nd'?: { item: string; value: number };
  '3rd'?: { item: string; value: number };
}

interface CompactPrizeBadgesProps {
  prizeDetails: PrizeDetails;
  className?: string;
}

export function CompactPrizeBadges({ prizeDetails, className = "" }: CompactPrizeBadgesProps) {
  const prizes = [
    {
      place: '1st',
      data: prizeDetails['1st'],
      emoji: '🎁',
      icon: '🚚'
    },
    {
      place: '2nd',
      data: prizeDetails['2nd'],
      emoji: '🎁',
      icon: '💸'
    },
    {
      place: '3rd',
      data: prizeDetails['3rd'],
      emoji: '🎁',
      icon: '🎟️'
    }
  ].filter(prize => prize.data);

  if (prizes.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-col md:flex-row gap-2 md:gap-4 items-stretch md:items-center justify-center ${className}`}>
      {prizes.map((prize, index) => (
        <div 
          key={`${prize.place}-${index}`}
          className="flex items-center text-blue-600 font-medium bg-white px-3 py-2 rounded-lg shadow-sm border border-blue-100 min-w-0 w-full md:w-auto md:flex-1"
        >
          <span className="text-lg mr-2 flex-shrink-0">{prize.emoji}</span>
          <span className="text-lg mr-2 flex-shrink-0">{prize.icon}</span>
          <span className="truncate text-sm sm:text-base">{prize.data!.item}</span>
        </div>
      ))}
    </div>
  );
}
